var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend legend-frozen"},[_c('span',{staticClass:"ib mr8"},[_vm._v("凍結:")]),_vm._l((_vm.dispData),function(e){
var _obj;
return _c('div',{key:e.val,staticClass:"cell mr2",class:( _obj = {}, _obj['val-'+e.val] = true, _obj )},[_c('div',{staticClass:"color",style:({'background-color': e.color})}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(e.label))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }